function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.284 7.2H5.858l3.934-4.127c.324-.34.502-.792.502-1.273 0-.48-.178-.933-.502-1.273A1.666 1.666 0 008.578 0C8.12 0 7.69.187 7.365.527l-6.863 7.2c-.24.253-.4.567-.467.909v.002c-.01.05-.017.102-.023.154l-.003.026a1.87 1.87 0 000 .365c0 .009.003.017.003.026.006.051.013.103.023.153v.003c.067.342.227.656.467.908l6.863 7.2c.324.34.755.527 1.213.527.459 0 .89-.187 1.214-.527a1.865 1.865 0 000-2.546L5.858 10.8h10.426C17.231 10.8 18 9.992 18 9c0-.993-.77-1.8-1.716-1.8z",
  fill: "#fff"
})));